//#region mobile-nav
import {
    faBedFront,
    faBus,
    faPlane,
    faTaxi,
    faTrainSubway,
    faCirclePlus,
    faTicket,
    faHome,
    faUser,
} from '@fortawesome/pro-regular-svg-icons';
import { type WritableComputedRef } from 'vue';

export const mobileNavBlackListData = [
    '/captcha-frame',
    '/reserve/',
    '/flights/',
    '/trains/',
    '/buses/',
    '/taxi/',
    '/hotel/',
    '/after-order/transporter',
];

export const services = [
    {
        label: 'بلیط هواپیما',
        icon: faPlane,
        href: '/plane-ticket',
    },
    {
        label: 'رزرو هتل',
        icon: faBedFront,
        href: '/hotel',
    },
    {
        label: 'بلیط قطار',
        icon: faTrainSubway,
        href: '/train-ticket',
    },
    {
        label: 'بلیط اتوبوس',
        icon: faBus,
        href: '/bus-ticket',
    },
    {
        label: 'بلیط سواری',
        icon: faTaxi,
        href: '/taxi',
    },
];

export const navOptions = [
    {
        href: '/',
        icon: faHome,
        activeIcon: faHome,
        label: 'خانه',
    },
    {
        href: '/services',
        icon: faCirclePlus,
        activeIcon: faCirclePlus,
        label: 'سفر جدید',
    },
    {
        onClick: () => {
            const onTracking = useBillTracking();
            onTracking();
        },
        icon: faTicket,
        activeIcon: faTicket,
        label: 'بلیط‌های من',
    },
    {
        href: '/profile',
        icon: faUser,
        activeIcon: faUser,
        label: 'حساب کاربری',
    },
];

//#endregion

// reserve-flow

export const ReserveFlowProviderKey = 'reserve-flow';

export type ReserveFlowProviderType = {
    stepper: (step?: number) => void;
    currentStep: WritableComputedRef<number>;
};
